import moment from '../../utils/moment';
import { calendarViewModes } from 'src/utils/useCalendar';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Model {
  [key: string]: any;
};

interface ArrayModel {
  date: any;
  viewMode: any;
  isLoading: any;
  events: any;
  hoverEvent: any;
  filterSchoolID: any;
  filterClassID: any;
  filterChildID: any;
  filterUserID: any;
  filterType: any;
};

const initialState: ArrayModel = {
  date: moment(),
  viewMode: calendarViewModes[2],
  isLoading: true,
  events: [],
  hoverEvent: null,
  filterSchoolID: [],
  filterClassID: [],
  filterChildID: [],
  filterUserID: [],
  filterType: [],
};

const slice = createSlice({
  name: 'calendar',
  initialState: initialState,
  reducers: {
    setCalendarDate(state, action: PayloadAction<Model>){
      state.date = action.payload;
    },
    setCalendarViewMode(state, action: PayloadAction<Model>){
      state.viewMode = action.payload;
    },
    setCalendarIsLoading(state, action: PayloadAction<Model>){
      state.isLoading = action.payload;
    },
    setCalendarEvents(state, action: PayloadAction<Model>){
      state.events = action.payload;
    },
    addCalendarEvent(state, action: PayloadAction<Model>){
      state.events = [...state.events, action.payload];
    },
    addCalendarEvents(state, action: PayloadAction<Model[]>){
      const newEvents = action.payload.filter((newEvent: any) => !state.events.some((existingEvent: any) => existingEvent.eventID === newEvent.eventID));
      state.events = [...state.events, ...newEvents];
    },
    editCalendarEvent(state, action: PayloadAction<Model>){
      const eventData = action.payload;
      state.events = state.events.map((item: any) => {
        if(item.eventID === eventData.eventID) {
          return eventData;
        } else {
          return item;
        }
      })
    },
    editCalendarEvents(state, action: PayloadAction<Model[]>) {
      const updatedEvents = action.payload;
      state.events = state.events.map((existingEvent: any) => {
        const found = updatedEvents.find(updated => updated.eventID === existingEvent.eventID);
        return found ? found : existingEvent;
      });
    },
    deleteCalendarEvent(state, action: PayloadAction<string>) {
      const idToDelete = action.payload;
      state.events = state.events.filter((event: any) => event.eventID !== idToDelete);
    },
    deleteCalendarEvents(state, action: PayloadAction<string[]>) {
      const idsToDelete = new Set(action.payload);
      state.events = state.events.filter((event: any) => !idsToDelete.has(event.eventID));
    },
    deleteCalendarRecurringEvents(state, action: PayloadAction<string>) {
      const idToDelete = action.payload;
      state.events = state.events.filter((event: any) => event.recurringEventID !== idToDelete);
    },
    deleteCalendarRecurringEventsSince(state, action: PayloadAction<{ recurringEventID: string; since: string }>) {
      const { recurringEventID, since } = action.payload;
      state.events = state.events.filter((event: any) => {
        return (event.recurringEventID !== recurringEventID || moment(event.dateTimeFrom).isBefore(moment(since)));
      });
    },
    setCalendarHoverEvent(state, action: PayloadAction<Model>){
      state.hoverEvent = action.payload;
    },
    setCalendarFilterSchoolID(state, action: PayloadAction<Model>){
      state.filterSchoolID = action.payload;
    },
    setCalendarFilterClassID(state, action: PayloadAction<Model>){
      state.filterClassID = action.payload;
    },
    setCalendarFilterChildID(state, action: PayloadAction<Model>){
      state.filterChildID = action.payload;
    },
    setCalendarFilterUserID(state, action: PayloadAction<Model>){
      state.filterUserID = action.payload;
    },
    setCalendarFilterType(state, action: PayloadAction<Model>){
      state.filterType = action.payload;
    },
  }
});

export const calendarSlice = slice;